import type { RelayMetadata } from '@/contexts/AppContext';

/**
 * App default relays. Used as the initial `relayMetadata` for new users and as
 * a fallback when the user has no NIP-65 relay list configured.
 *
 * Read relays are chosen for video-event coverage: many NIP-71 videos are only
 * published to large general relays (damus, snort, primal, nostr.wine) or to
 * DiVine's own relay, so a small read set silently drops a big share of
 * existing videos.
 *
 * relay.divine.video supports NIP-50 full-text search, which powers VidStr's
 * video search.
 */
export const APP_RELAYS: RelayMetadata = {
  relays: [
    { url: 'wss://relay.ditto.pub/', read: true, write: true },
    { url: 'wss://relay.dreamith.to/', read: true, write: true },
    { url: 'wss://relay.divine.video/', read: true, write: false },
    { url: 'wss://relay.damus.io/', read: true, write: false },
    { url: 'wss://relay.snort.social/', read: true, write: false },
    { url: 'wss://relay.primal.net/', read: true, write: true },
    { url: 'wss://nos.lol/', read: true, write: true },
    { url: 'wss://nostr.wine/', read: true, write: false },
  ],
  updatedAt: 0,
};
